export default  {
	id: '',
	name: '',
	property: '',
	acreage: ''
}